import React from "react";
import * as Yup from "yup";
import themeStyles from "../../../shared/styles/theme/theme-styles.module.scss";
import Form from "../../components/formWrapper/FormWrapper";
import "./forgetPasswordBox.scss";
import { sendForgotPassword } from "../../../services/loginService";
import { validateEmail } from "../../../shared/utils/validation";
import ForgetPasswordForm from "./forgetPasswordForm";
import { success, error } from "../../components/toast/toast";

const ForgetPasswordBox = (props) => {
  const { onCancel } = props;

  const handleSubmit = (email) => {
    sendForgotPassword(email).then((res) => {
      if (res.errors) {
        console.log(res.errors);
        error(res.errors);
      } else {
        success("Instructions were sent to your email", { onClose: onCancel });
      }
    });
  };

  const renderComponent = (props) => {
    return (
      <ForgetPasswordForm
        {...props}
        handleSubmit={handleSubmit}
        onCancel={onCancel}
      />
    );
  };

  const { className, title } = props;

  return (
    <div className={className || ""}>
      <h3
        className={themeStyles.headerSmInverted}
        style={{ marginBottom: "3em" }}
      >
        {title}
      </h3>
      <Form
        initialValues={{ email: "" }}
        component={renderComponent}
        validationSchema={Yup.object().shape({
          email: validateEmail("Invalid Email").required("Required Field"),
        })}
      />
    </div>
  );
};

export default ForgetPasswordBox;
